module.exports = __webpack_public_path__ + "img/email_plcaholder_4x.49078538.png";